module.exports = __webpack_public_path__ + "static/media/sound.f0cdd9bc.svg";